import { Pipe, PipeTransform } from '@angular/core';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { TranslateService } from '@ngx-translate/core';
import { TechnicalDocumentType } from '../domain/models/ExportOfferDocument';
import { Lang } from '../ui/util/langs';

@Pipe({
  name: 'technicalDocumentTypeName',
  pure: false
})
export class TechnicalDocumentTypeNamePipe implements PipeTransform {

  constructor(private _authService: AuthGateway, public translate: TranslateService) {
  }

  transform(technicalDocumentType: TechnicalDocumentType | undefined): string {

      if(!technicalDocumentType)
        return this.translate.instant('CommonLabels.NotAvailableLabel')

      let lang = Lang.ENGLISH;

      const profile = this._authService.getUser()
      if(profile)
      {
        lang = profile.lang;
      }else{
        lang = this.translate.currentLang;
      }

      switch(lang)
      {
        case Lang.ENGLISH:
          return technicalDocumentType.name;
        case Lang.SPANISH:
          return technicalDocumentType.nameEs;
        default:
          return this.translate.instant('CommonLabels.NotAvailableLabel')
      }
  }

}
